import { render } from "./Au2FA.vue?vue&type=template&id=5b39df99&scoped=true"
import script from "./Au2FA.vue?vue&type=script&lang=js"
export * from "./Au2FA.vue?vue&type=script&lang=js"

import "./Au2FA.vue?vue&type=style&index=0&id=5b39df99&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b39df99"]])

export default __exports__